import { useState, useEffect } from "react";
import { KineticText } from "../components/KineticText";
import { Reveal } from "../components/Reveal";
import { RichText } from "../components/RichText";
import { TextWithImage } from "../components/TextWithImage";
import { Footer } from "../components/Footer";
import { fetchSiteContent } from "../lib/api";
import { useLang } from "../context/LanguageContext";

const hasText = (html) => !!(html || "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();

export default function Contacts() {
  const { t, L } = useLang();
  const [content, setContent] = useState(null);
  useEffect(() => {
    fetchSiteContent().then(setContent).catch((e) => { console.error("site content failed:", e); setContent({}); });
  }, []);
  const details = (content && L(content, "contacts_text")) || "";
  const image = (content && content.contacts_image) || "";
  const intro = (content && L(content, "contacts_intro")) || "";
  const rawTitle = ((content && L(content, "contacts_title")) || "").trim();
  const titleLines = rawTitle ? rawTitle.split("\n").filter((l) => l.trim()) : [t("contacts_t1"), t("contacts_t2")];

  return (
    <main data-testid="contacts-page" className="min-h-screen">
      <section className="mx-auto max-w-[1600px] px-6 md:px-12 pt-40 md:pt-52 pb-24">
        <p className="font-mono text-[11px] tracking-[0.4em] uppercase text-[var(--vsl-green)] mb-6">{t("contacts_eyebrow")}</p>
        {content ? (
          <KineticText lines={titleLines}
            className="font-display text-[13vw] md:text-[8vw] leading-[0.9] tracking-[-0.01em]" />
        ) : (
          <h1 aria-hidden className="font-display text-[13vw] md:text-[8vw] leading-[0.9] tracking-[-0.01em] opacity-0">
            {[t("contacts_t1"), t("contacts_t2")].map((l) => <span key={l} className="block">{l}</span>)}
          </h1>
        )}
      </section>

      <section className="mx-auto max-w-[1600px] px-6 md:px-12 pb-32">
        <TextWithImage imageUrl={image} width={content?.contacts_image_w} height={content?.contacts_image_h}
          caption={L(content, "contacts_caption")} testid="contacts-image">
          <div className="space-y-10">
            <Reveal>
              {hasText(intro) && (
                <RichText testid="contacts-intro" html={intro}
                  className="contacts-rich font-display text-3xl md:text-4xl leading-[1.2] text-[var(--vsl-limestone)]" />
              )}
            </Reveal>
            {hasText(details) && (
              <Reveal className="border-t border-[var(--vsl-border)] pt-4">
                <RichText testid="contacts-details"
                  html={details}
                  className="contacts-rich font-mono text-lg md:text-xl leading-relaxed" />
              </Reveal>
            )}
          </div>
        </TextWithImage>
      </section>

      <Footer content={content} />
    </main>
  );
}
